import React from "react";
import { Col, Row } from "react-bootstrap";
import { formatDate } from "../../../../common/Validations";

const PrintInvoice = React.forwardRef((props, ref) => {
  const tableStyle = {
    border: "1px solid black ",
    borderCollapse: "collapse",
    padding: "4px",
  };
  const totalTableStyle = {
    textAlign: "right",
    fontWeight: "bold",
    padding: "8px",
    border: "1px solid black",
  };

  const printbody = {
    display: "flex",
    flexDirection: "column",
    margin: "10px",
  };

  const { data } = props;

  const totalNetValue = data?.items?.reduce(
    (sum, item) => sum + (item.qtnitemValue || 0),
    0
  );

  const itemTotal = data?.items?.reduce(
    (sum, item) => sum + (item.qtnitemValue || 0),
    0
  );

  const otherCharges = data?.qtnSubTotalOtherCharges || 0;

  const sgst = itemTotal * 0.025;
  const cgst = itemTotal * 0.025;
  const totalTax = sgst + cgst;
  const total = itemTotal + otherCharges + totalTax;

  const convertNumberToWords = (totalNetValue) => {
    if (totalNetValue === "" || isNaN(totalNetValue)) return "";
    let num = parseFloat(totalNetValue).toFixed(2);
    let [rupees, paise] = num.split(".");
    rupees = parseInt(rupees);
    paise = parseInt(paise);

    const ones = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];

    const tens = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];

    const scales = ["", "Thousand", "Million", "Billion", "Trillion"];

    const convertBelowThousand = (n) => {
      if (n < 20) return ones[n];
      if (n < 100)
        return (
          tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " " + ones[n % 10] : "")
        );
      return (
        ones[Math.floor(n / 100)] +
        " Hundred" +
        (n % 100 !== 0 ? " " + convertBelowThousand(n % 100) : "")
      );
    };

    let words = "";
    let scaleIndex = 0;

    while (rupees > 0) {
      let part = rupees % 1000;
      if (part !== 0) {
        words =
          convertBelowThousand(part) +
          " " +
          scales[scaleIndex] +
          (words ? " " + words : "");
      }
      rupees = Math.floor(rupees / 1000);
      scaleIndex++;
    }

    words = words.trim() ? words.trim() + " Rupees" : "";

    if (paise > 0) {
      let paiseWords = convertBelowThousand(paise) + " Paise";
      words += " and " + paiseWords;
    }

    return words || "Zero Rupees";
  };

  return (
    <div ref={ref} style={printbody} className="m-4">
      <p className="text-center fs-4 fw-bold text-primary">PURCHASE ORDER</p>
      <Row>
        <Col xs={12} md={12} lg={12} className="d-flex"></Col>
        <Col xs={12} md={12} lg={12} className="d-flex">
          <Col xs={1} md={1} lg={1}>
            <p className="fs-5 mb-0 text-nowrap">Ack Date</p>
          </Col>
          <Col xs={10} md={10} lg={10}>
            <p className="fs-5 fw-bold me-4 mb-0">
              : {formatDate(data?.createdAt)}
            </p>
          </Col>
        </Col>
      </Row>

      {/* table-01 */}
      <table className="w-100" style={tableStyle}>
        {/* row-1 */}
        <tr style={tableStyle}>
          <td rowSpan={3} className="w-50" style={tableStyle}>
            <span className="fw-bold">{data?.companyCodeDesc}</span>
            <p className="mb-0">{data?.companyAddress}</p>
            {data?.companyCertifications && data?.companyCertifications[0] && (
              <p className="mb-0">
                GSTIN/UIN : {data?.companyCertifications[0]?.documentNumber}
              </p>
            )}
            <br />
          </td>
          <td className="w-25" style={tableStyle}>
            <Row>
              <Col lg={6} className="d-flex flex-column">
                <span>PO No.</span>
                <span className="fw-bold">{data?.documentNumber}</span>
              </Col>
              {data?.e_WayBillNo && (
                <Col lg={6} className="d-flex flex-column">
                  <span> e-Way Bill No.</span>
                  <span className="fw-bold">{data?.e_WayBillNo}</span>
                </Col>
              )}
            </Row>
          </td>
          <td style={tableStyle}>
            Dated<p className="m-0 fw-bold">{formatDate(data?.createdAt)}</p>
          </td>
        </tr>
        <tr></tr>
        <tr>
          <td style={tableStyle}>
            <Col lg={6} className="d-flex flex-column">
              <span>Buyer's Order No.</span>
              <span className="fw-bold">{data?.quotationNr}</span>
            </Col>
          </td>
        </tr>
        {/* row-2 */}
        <tr style={tableStyle}>
          <td rowSpan={3} className="w-50" style={tableStyle}>
            <p className="m-0">Vendor</p>
            <span className="fw-bold">{data?.organisationName}</span>
            <br />
            <span>{data?.deliveryAddressCodeDesc}</span>
            <br />
            {data?.items &&
              data?.items[0] &&
              data?.items[0]?.certifications &&
              data?.items[0]?.certifications[0] && (
                <p className="mb-0">
                  GSTIN/UIN :{" "}
                  {data?.items[0]?.certifications[0]?.documentNumber}
                </p>
              )}
            <span>State Name : Karnataka, Code : 29</span>
            <br />
            <br />
          </td>
          <td style={tableStyle}></td>
          <td style={tableStyle}> Delivery Note Date</td>
        </tr>
        <tr>
          <td style={tableStyle}>Dispatched through</td>
          <td style={tableStyle}>Destination</td>
        </tr>
        <tr>
          <td style={tableStyle}></td>
        </tr>
        {/*  row-3*/}
        <tr style={tableStyle}>
          <td className="w-50" style={tableStyle}>
            <p className="m-0">Ship To</p>
            <span className="fw-bold">{data?.organisationName}</span>
            <br />
            <span>{data?.deliveryAddressCodeDesc}</span>
            <br />
            <span>State Name : Karnataka, Code : 29</span>
            <br />
            {data?.items &&
              data?.items[0] &&
              data?.items[0]?.certifications &&
              data?.items[0]?.certifications[0] && (
                <p className="mb-0">
                  GSTIN/UIN :{" "}
                  {data?.items[0]?.certifications[0]?.documentNumber}
                </p>
              )}
            <span> Place of Supply : Karnataka</span>
          </td>
          <td colSpan={2} className="d-flex">
            Terms of Delivery
          </td>
        </tr>
      </table>

      {/* table 2 */}
      <table
        style={{ marginTop: "16px", width: "100%", borderCollapse: "collapse" }}
      >
        <table
          className="w-100"
          style={{ ...tableStyle, tableLayout: "fixed" }}
        >
          <tr style={tableStyle} className="fw-bold">
            <td
              style={{
                width: "60px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                fontSize: "12px",
              }}
            >
              Sl.No.
            </td>
            <td style={tableStyle} className="w-25 fw-bold">
              Material/Service
            </td>
            <td style={tableStyle} className="fw-bold">
              Material Code
            </td>
            <td style={tableStyle} className="fw-bold">
              Quantity
            </td>
            <td style={tableStyle} className="fw-bold">
              Order Unit
            </td>
            <td style={tableStyle} className="fw-bold">
              Unit Price
            </td>
            <td style={tableStyle} className="fw-bold">
              Net Value
            </td>
          </tr>

          {/* ======== map items ============= */}
          {data?.items?.map((item, i) => (
            <tr key={i} style={tableStyle}>
              <td
                style={{
                  width: "60px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  fontSize: "12px",
                }}
              >
                {i + 1}.
              </td>
              <td style={tableStyle}>
                <Row>
                  <Col xs={6} md={6} lg={6} className="fw-bold">
                    {item?.materialDescription}
                  </Col>
                </Row>
              </td>
              <td style={tableStyle}>{item?.materialCode}</td>
              <td style={tableStyle} className="fw-bold text-end ">
                {item?.indentQuantity}{" "}
              </td>
              <td style={tableStyle}>{item?.orderUnitOfMeasure}</td>
              <td style={tableStyle} className="text-bold text-end">
                {item?.quotationUnitPrice}
              </td>
              <td style={tableStyle} className="fw-bold text-end">
                {Number(item?.qtnitemValue).toFixed(2)}
              </td>
            </tr>
          ))}
        </table>
        {/* Changed this section to use flexbox for better alignment */}
        <div style={{ display: "flex", width: "100%" }}>
          <div style={{ flex: 2.5}}> {/* This will take roughly 2/3 of the width */}
            <table className="w-100" style={tableStyle}>
              <tr style={tableStyle}>
                <td style={tableStyle}>
                  <Row>
                    <Col xs={10} md={10} lg={10} className="my-4">
                      <span className="me-2">Tax Amount (in words) :</span>
                      <span className="fw-bold text-nowrap">
                        INR {convertNumberToWords(total)} Only
                      </span>
                    </Col>
                    <Col xs={7} md={7} lg={7}>
                      <p className="m-0 text-decoration-underline">
                        Declaration
                      </p>
                      <p className="m-0">
                        We declare that PO shows the actual price of the goods
                        described and that all particulars are true and correct.
                        Payment : 10 days credit once Bill Invoice received.
                        Every load will be unloaded after Quality Inspection.
                      </p>
                    </Col>
                  </Row>
                </td>
              </tr>
            </table>
          </div>
          <div style={{ flex: 1 }}> {/* This will take roughly 1/3 of the width */}
            <table className="w-100" style={tableStyle}>
              <tr>
                <td
                  colSpan={6}
                  style={{
                    textAlign: "right",
                    fontWeight: "bold",
                    padding: "8px",
                    border: "1px solid black",
                  }}
                >
                  SUBTOTAL
                </td>
                <td
                  style={{
                    textAlign: "right",
                    fontWeight: "normal",
                    padding: "8px",
                    border: "1px solid black",
                  }}
                >
                  {totalNetValue?.toFixed(2)}
                </td>
              </tr>
              <tr>
                <td
                  colSpan={6}
                  style={{
                    textAlign: "right",
                    fontWeight: "bold",
                    padding: "8px",
                    border: "1px solid black",
                  }}
                >
                  Other Charges
                </td>
                <td
                  style={{
                    textAlign: "right",
                    fontWeight: "normal",
                    padding: "8px",
                    border: "1px solid black",
                  }}
                >
                  {otherCharges?.toFixed(2)}
                </td>
              </tr>
              <tr>
                <td
                  colSpan={6}
                  style={{
                    textAlign: "right",
                    fontWeight: "bold",
                    padding: "8px",
                    border: "1px solid black",
                  }}
                >
                  SGST 2.5%
                </td>
                <td
                  style={{
                    textAlign: "right",
                    fontWeight: "normal",
                    padding: "8px",
                    border: "1px solid black",
                  }}
                >
                  {sgst.toFixed(2)}
                </td>
              </tr>
              <tr>
                <td
                  colSpan={6}
                  style={{
                    textAlign: "right",
                    fontWeight: "bold",
                    padding: "8px",
                    border: "1px solid black",
                  }}
                >
                  CGST 2.5%
                </td>
                <td
                  style={{
                    textAlign: "right",
                    fontWeight: "normal",
                    padding: "8px",
                    border: "1px solid black",
                  }}
                >
                  {cgst?.toFixed(2)}
                </td>
              </tr>
              <tr style={{ borderBottom: "none" }}>
                <td
                  colSpan={6}
                  style={{ ...totalTableStyle, backgroundColor: "#dbe5f1" }}
                >
                  TOTAL
                </td>
                <td
                  style={{
                    ...totalTableStyle,
                    backgroundColor: "#dbe5f1",
                    textAlign: "end",
                  }}
                >
                  <strong>{total?.toFixed(2)} INR</strong>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </table>
      <div className="text-center ">
        <p>SUBJECT TO BENGALURU JURISDICTION</p>
        <p>This is a Computer Generated Invoice</p>
      </div>
    </div>
  );
});

export default PrintInvoice;